import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generateClinicalDocumentationPDF = (data) => {
  const doc = new jsPDF("p", "mm", "a4");

  // Header
  doc.setFontSize(18);
  doc.setTextColor(0, 59, 117);
  doc.text("Clinical Documentation Query", 105, 18, {
    align: "center",
  });

  doc.setFontSize(11);
  doc.setTextColor(100);

  doc.text("Ambiguous Documentation Clarification", 105, 25, {
    align: "center",
  });

  // Episode Information
  autoTable(doc, {
    startY: 35,
    theme: "grid",
    head: [["Field", "Value"]],
    body: [
      ["MRN", data.mrn],
      ["Episode ID", data.episodeId],
      ["Hospital", data.hospital],
      ["Length of Stay", data.los],
      ["Admission Date", data.admissionDate],
      ["Separation Date", data.separationDate],
      ["Clinician", data.clinician],
      ["Specialty", data.specialty],
    ],
  });

  let y = doc.lastAutoTable.finalY + 10;

  doc.setFontSize(13);
  doc.setTextColor(0);
  doc.text("CDQ Category", 14, y);

  doc.setFontSize(11);
  doc.text(data.category || "", 14, y + 7);

  y += 18;

  doc.setFontSize(13);
  doc.text("Query", 14, y);

  doc.setFontSize(11);

  doc.text(
    "There is mention of more than one condition that may meet criteria for principal diagnosis. If possible, can you please confirm the principal diagnosis for this episode of care?",
    14,
    y + 7,
    { maxWidth: 180 }
  );

  y += 35;

  doc.setFontSize(13);
  doc.text("Response", 14, y);

  doc.setFontSize(11);
  doc.text(data.responseOption || "-", 14, y + 7);

  if (data.otherText) {
    doc.text(`Other: ${data.otherText}`, 14, y + 15);
  }

  y += 30;

  autoTable(doc, {
    startY: y,
    theme: "grid",
    head: [["Field", "Value"]],
    body: [
      ["Responding Clinician", data.clinicianName],
      ["Clinician Specialty", data.clinicianSpecialty],
      ["Response Date", data.responseDate],
      ["Response Time", data.responseTime],
      ["Generated By", data.generatedBy],
      ["Generated On", data.generatedOn],
    ],
  });

  // Open PDF in new tab
  window.open(doc.output("bloburl"), "_blank");
};